import React from 'react';
import './_badge.scss';

interface Props {
  label: React.ReactNode;
  size: 'lg' | 'sm';
  type: 'primary' | 'secondary' | 'success' | 'warning' | 'danger';
  className?: string;
}

export const Badge = (props: Props) => {
  const { label, size, type, className } = props;
  return (
    <div className={`badge ${size} ${type}${className ? ` ${className}` : ''}`}>
      {label}
    </div>
  );
};
